import { MenuLink } from "../shared/interface/bcmenulink";



const menuUser: MenuLink[] = [
  {
    iconLink: "home",
    path: "/",
    label: "Inicio",
  },
  {
    iconLink: "book",
    path: "/brief/crear/campaign",
    label: "Brief Campañas",
  },
  {
    iconLink: "book",
    path: "/brief/crear/iniciative",
    label: "Brief Iniciativas",
  },
  {
    iconLink: "book",
    path: "/brief/crear/tactic",
    label: "Brief Tactico",
  },
  {
    iconLink: "list",
    path: "/brief/me",
    label: "Mis Brief",
  },
];

const menuAdmin: MenuLink[] = [
  {
    iconLink: "home",
    path: "/",
    label: "Inicio",
  },
  {
    iconLink: "book",
    path: "/brief/crear/campaign",
    label: "Brief Campañas",
  },
  {
    iconLink: "book",
    path: "/brief/crear/iniciative",
    label: "Brief Iniciativas",
  },
  {
    iconLink: "book",
    path: "/brief/crear/tactic",
    label: "Brief Tactico",
  },
  {
    iconLink: "list",
    path: "/brief/me",
    label: "Mis Brief",
  },
  {
    iconLink: "list",
    path: "/brief/list",
    label: "Todos de Brief",
  },
];

export { menuUser, menuAdmin  };
